import { Link } from "react-router-dom";

type Props = {
  claims: any[];
};

const SidebarClaim = ({ claims }: Props) => {
  return (
    <div className="col-xl-4 col-xxl-3 theiaStickySidebar">
      <div className="stickybar">
        <div className="card">
          <div className="card-header p-3">
            <h4>Statistiques Réclamations</h4>
          </div>
          <div className="card-body p-0">
            <div className="d-flex flex-column">
              <div className="d-flex align-items-center justify-content-between border-bottom p-3">
                <Link to="#">Total Réclamations</Link>
                <div className="d-flex align-items-center">
                  <span className="badge badge-soft-primary">
                    {claims.length}
                  </span>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between border-bottom p-3">
                <Link to="#">Envoyées</Link>
                <div className="d-flex align-items-center">
                  <span className="badge badge-soft-warning">
                    {
                      claims.filter((claim) => claim.statut_claim === "Envoyé")
                        .length
                    }
                  </span>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between border-bottom p-3">
                <Link to="#">Traitées</Link>
                <div className="d-flex align-items-center">
                  <span className="badge badge-soft-success">
                    {
                      claims.filter((claim) => claim.statut_claim === "Traité")
                        .length
                    }
                  </span>
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-between p-3">
                <Link to="#">Clôturées</Link>
                <div className="d-flex align-items-center">
                  <span className="badge badge-soft-secondary">
                    {
                      claims.filter((claim) => claim.statut_claim === "Clôturé")
                        .length
                    }
                  </span>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between border-bottom p-3">
                <Link to="#">Annulées</Link>
                <div className="d-flex align-items-center">
                  <span className="badge badge-soft-danger">
                    {
                      claims.filter((claim) => claim.statut_claim === "Annulé")
                        .length
                    }
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SidebarClaim;
